import SpriteSymbol from "../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caretup",
  "use": "caretup-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"caretup\"><path d=\"M1.188 9.891L7.516 2.25q.203-.219.5-.219t.5.219l6.297 7.641q.281.313.109.711t-.609.398H1.688q-.438 0-.609-.398t.109-.711z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/caretup.svg
// module id = 1019
// module chunks = 0